'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createStack = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _freeze = require('./helpers/freeze');

var _freeze2 = _interopRequireDefault(_freeze);

var _promise = require('./helpers/promise');

var _polyfillCheck = require('./polyfillCheck');

var _polyfillCheck2 = _interopRequireDefault(_polyfillCheck);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

(0, _polyfillCheck2.default)();

var promisifyMiddleware = function promisifyMiddleware(mw, options) {
  return _promise.Promise.resolve(mw((0, _freeze2.default)(_extends({}, options, { _input: options }))));
};

var createStack = exports.createStack = function createStack() {
  for (var _len = arguments.length, fns = Array(_len), _key = 0; _key < _len; _key++) {
    fns[_key] = arguments[_key];
  }

  var first = fns[0],
      rest = fns.slice(1);


  return function (options) {
    if (rest.length === 0) {
      return promisifyMiddleware(first, options);
    }

    return rest.reduce(function (composed, current) {
      return composed.then(current);
    }, promisifyMiddleware(first, options));
  };
};